import React from 'react';
import {Trans} from 'react-i18next';
import {Entry, TimelineEntryWithUpdates} from './Shared';

export const CustomerUpdatedTimelineEntry = ({entry}) => {
    return (
        <TimelineEntryWithUpdates entry={entry} status="change" icon="person">
            <Entry.Title>
                <Trans i18nKey="warehousing.timeline.CustomerUpdated.title" values={{name: entry.customerName}} />
            </Entry.Title>
        </TimelineEntryWithUpdates>
    );
};
